export enum ChartType {
  Bar = 'bar',
  Line = 'line',
  Pie = 'pie',
}

export interface WidgetChart {
  orderIndex: number;
  type: ChartType;
  data: { labels: string[]; values: number[] };
}
